import { InsightMetric } from 'types/Insights';

// Pilot (ENG-5006): hardcoded from Science's "Mapping videos to metrics" sheet.
// Keys are age-banded gut_vaginal_health ids, so the age gate comes for free.

type TriggerLabel =
  | 'Absent'
  | 'Low'
  | 'Borderline Low'
  | 'Borderline High'
  | 'High';

export interface MetricVideo {
  youtubeId: string;
  triggers: TriggerLabel[];
}

const LOW: TriggerLabel[] = ['Absent', 'Low', 'Borderline Low'];
const HIGH: TriggerLabel[] = ['Borderline High', 'High'];
const HIGH_ONLY: TriggerLabel[] = ['High'];

export const METRIC_VIDEOS: Record<number, MetricVideo> = {
  // Mucus degradation index
  659: { youtubeId: 'E8oPUerHGHM', triggers: HIGH_ONLY },
  660: { youtubeId: 'MbVHtZflfKQ', triggers: HIGH },
  661: { youtubeId: '1l6a5A5FqhE', triggers: HIGH },
  // Hexa-LPS index
  654: { youtubeId: '74Uby5tIp5Q', triggers: HIGH_ONLY },
  655: { youtubeId: 'M_Q1gHAwalo', triggers: HIGH_ONLY },
  656: { youtubeId: 'NjI3Ic_dQgY', triggers: HIGH },
  // Hydrogen sulfide index
  664: { youtubeId: 'F_w7gb57gW8', triggers: HIGH_ONLY },
  665: { youtubeId: '9tgUaKDPkjg', triggers: HIGH },
  666: { youtubeId: 'wIDK0zo3Pt8', triggers: HIGH },
  // Bifidobacterium
  28: { youtubeId: 'aS_Sd9wUgqI', triggers: LOW },
  56: { youtubeId: 'aS_Sd9wUgqI', triggers: LOW },
  671: { youtubeId: 'aS_Sd9wUgqI', triggers: LOW },
  // Bacteroides fragilis
  397: { youtubeId: 'f1WMLwo7YzA', triggers: HIGH },
  398: { youtubeId: 'f1WMLwo7YzA', triggers: HIGH },
  399: { youtubeId: 'mjWG1Bjb8T8', triggers: HIGH },
  // Ruminococcus gnavus
  401: { youtubeId: 'E4J-SaS4Tfk', triggers: HIGH },
  653: { youtubeId: 'vNWVK3vtNu8', triggers: HIGH },
  402: { youtubeId: '1P-c8EjTEZg', triggers: HIGH },
};

const POOR_COLORS = ['red', 'orange'];

export const getMetricId = (metric: Partial<InsightMetric>) =>
  metric.sample_health_id ?? metric.gut_vaginal_health?.id;

export const getMetricVideo = (
  metric: Partial<InsightMetric>,
): MetricVideo | null => {
  const metricId = getMetricId(metric);
  const video = metricId ? METRIC_VIDEOS[metricId] : undefined;
  if (!video) return null;
  if (!POOR_COLORS.includes(metric.evaluation_color ?? '')) return null;

  const label = metric.evaluation_text as TriggerLabel | undefined;
  return label && video.triggers.includes(label) ? video : null;
};

export const getYouTubeThumbnails = (youtubeId: string) => ({
  vertical: `https://i.ytimg.com/vi/${youtubeId}/oar2.jpg`,
  fallback: `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`,
});
